
var THF = THF || {};
THF.Interface = THF.Interface || {};
(function ($, jQuery) {
    'use strict';

    THF.Interface.NewsArticleListing = function (options) {

        var defaults = {

            apiConfig: {
                endPoint: '/api/v1/news/articles/',
                pageSize: 6,
            },

            currentPage: 0,
            selectors: {
                //Module Parent
                parentElem: '.category-article-list',
                tileRow: '.tile-container-row',
                btnLoadMore: '.btn-load-more',

                articleTile: '.article-tile-featured',
                serviceTile: '.hh-service-tile',

                pagination: '.pagination',
                paginationProgress: '.pagination-process-bar .inner',
                currentlyShowing: '.pagination .currently-showing',
                totalResults: '.pagination .total-results'
            },

        };

        options = $.extend(true, {}, defaults, options);


        /**********************************
         // Declare DOM elements
         **********************************/
        var parentElem = $(options.selectors.parentElem);
        var $tileRow = $parentElem(options.selectors.tileRow);
        var $btnLoadMore = $parentElem(options.selectors.btnLoadMore);

        var $pagination = $parentElem(options.selectors.pagination);
        var $paginationProgress = $parentElem(options.selectors.paginationProgress);
        var $currentlyShowing = $parentElem(options.selectors.currentlyShowing);
        var $totalResults = $parentElem(options.selectors.totalResults);

        var catId = parentElem.data('category-id');


        /**********************************
         // Helper function to return a jQuery object, which is a child of 'parentElem'
         **********************************/
        function $parentElem(selector) {
            return $(options.selectors.parentElem + ' ' + selector);
        }

        /**********************************
         // Template Generators
         **********************************/
        function getArticleTile(articleObj) {
            var imgBlock = '';
            if (articleObj.image_lg) {
                imgBlock =
                    '<div class="img-block">\n' +
                    '    <picture>\n' +
                    '        <source srcset="' + articleObj.image_lg + '" media="(min-width: 993px)">\n' +
                    '        <img srcset="' + articleObj.image_xs + '" alt="' + articleObj.image_alt + '" loading="lazy">\n' +
                    '    </picture>\n' +
                    '</div>\n';
            }

            var articleTile =
                '<div class="col-xs-12 col-md-4" style="display: none;">\n' +
                '    <a href="' + articleObj.link + '" target="' + articleObj.navigationInNewTab+'" class="article-tile-featured">\n' +
                           imgBlock +
                '           <div class="content-block">\n' +
                '               <p class="title">' + articleObj.title + '</p>\n' +
                '               <p class="desc">' + articleObj.description + '</p>\n' +
                '               <div class="link-row">\n' +
                '                   <div class="author">\n' +                                      
                '                       <p class="author-name">' + articleObj.publishedDate + '</p>\n' +
                '                   </div>\n' +
                '                   <div class="link">\n' +
                '                       <span class="txt">Read more</span>\n' +
                '                       <svg class="icon icon-arrow-right" preserveAspectRatio="xMidYMid meet"><use xlink:href="/static/svg/sprite.svg#ui-arrow-right"></use></svg>\n' +
                '                   </div>\n' +
                '               </div>\n' +
                '           </div>\n' +
                '        </a>\n' +
                '</div>';

            return articleTile;
        }
        
        /**********************************
         // State Management
         **********************************/
        function setErrorState(bool) {

            if (bool === true) {
                parentElem.addClass('error-occurred');
                $btnLoadMore.html('Try again?');
            } else {
                parentElem.removeClass('error-occurred');
                $btnLoadMore.html('Load More');
            }
        }




        function updatePagination(loaded, total) {
            var percentageLoaded = (loaded / total * 100) + '%';
            $paginationProgress.css('width', percentageLoaded);
            $currentlyShowing.html(loaded);
            $totalResults.html(total);

            if (loaded === total) {
                $btnLoadMore.addClass('disabled');
            }
        }


        /**********************************
         // API methods
         **********************************/
        function buildApiUrl(catId, pageSize, pageNumber) {
            var apiUrl = options.apiConfig.endPoint + catId + '/page?pageSize=' + pageSize + '&page=' + pageNumber;
            return apiUrl;
        }


        function fetchPage(pageNumber, loadMoreButtonClicked) {
            var apiUrl = buildApiUrl(catId, options.apiConfig.pageSize, pageNumber);
            $.ajax({
                type: 'GET',
                crossDomain: true,
                dataType: 'JSON',
                url: apiUrl,
            })
                .done(function (response) {
                    appendPage(response.items);
                    setErrorState(false);
                    updatePagination(response.loaded, response.total);
                    initCategoryArticleListTracking();

                    // Track only when 'Load More' button is clicked
                    if (loadMoreButtonClicked) {
                        initLoadMoreTracking(response.loaded, response.total);
                    }
                    
                })

                .fail(function (jqXHR, textStatus, errorThrown) {
                    setErrorState(true);
                });
        }

        /**********************************
         // Rendering
         **********************************/
        function appendPage(pageItems) {
            pageItems.forEach(function (obj) {
                var tileMarkup = getArticleTile(obj);               

                $tileRow
                    .append(tileMarkup)
                    .children()
                    .delay(150)
                    .fadeIn(350);



            });

            //Increase the page count
            options.currentPage++;

        }

        /**********************************
         // Event binding
         **********************************/
        function bindEvents() {
            $btnLoadMore.click(function (e) {
                fetchPage(options.currentPage + 1, true);
            });
        }


        /**********************************
       // Load More Button Tracking
       **********************************/
        function initLoadMoreTracking(loaded, total) {
            if (total > 0) {
                var loadedMessage = loaded + ' of ' + total + ' results';
                //console.log(loadedMessage);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'showMore',
                    'results': loadedMessage
                });
            }
        }


        /**********************************
        // Category Article List Tracking
        **********************************/
        function initCategoryArticleListTracking() {

            // Find service Tile 
            var $serviceTiles = $('.category-article-list .hh-service-tile');
            if ($serviceTiles.length > 0) {
                $serviceTiles.each(function () {
                    var current = $(this);
                    /* Find Service Tile that has not binded to click event */
                    var serviceTileButton = current.find('a:not(.bound)');

                    /* Add bound class once the click event is binded to it serviceTileButton */
                    serviceTileButton.addClass('bound').click(function (e) {
                        //e.preventDefault();
                        //console.log('Category Landing Page >> Service Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'categoryMainCard',
                            'type': 'Service',
                            'pagePath': $(this).attr('href')
                        });
                    });
                });
            }

            // Find service Tile 
            var $articleTiles = $('.category-article-list .article-tile-featured');
            if ($articleTiles.length > 0) {
                $articleTiles.each(function () {
                    /* Find article tile that has not binded to click event */
                    var articleTileButton = $(this).not('.bound');

                    /* Add bound class once the click event is binded to it serviceTileButton */
                    articleTileButton.addClass('bound').click(function (e) {
                        //e.preventDefault();
                        //console.log('Category Landing Page >> Article Tile clicked.');
                        //console.log($(this).attr('href'));
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'categoryMainCard',
                            'type': 'Article',
                            'pagePath': $(this).attr('href')
                        });

                    });
                });
            }
        }

        /**********************************
         // Simple constructor
         **********************************/
        function __construct() {

            // Init
            if (parentElem.length > 0) {
                fetchPage(1, false);
                bindEvents();
            }
        }

        __construct();


        //
        // Make some events accessible from global scope
        //
        return {

        };
    };


})(jQuery, jQuery);


